import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';

import { LoginInfoProvider } from '../ev-dal/login-info.provider';
import { RouteDataService } from './route-data.service';


@Injectable({
  providedIn: 'root'
})
export class ResolverService implements Resolve<any> {

  extras = {relativeTo: this.routes};
  roles = ['admin', 'student', 'coach', 'parent'];

  constructor(
    private router: Router,
    private routes: ActivatedRoute,
    private loginInfoProvider: LoginInfoProvider,
    private routeDataService: RouteDataService
  ) { }


  format(str) {
    return str.replace(/ /g, '').toLowerCase().split(',');
  }

  resolve(route: ActivatedRouteSnapshot) {

    const loginInfo = this.loginInfoProvider.loginInfo;
    const baseRoute = route['_routerState'].url.split('/')[1];
    const isLogin = loginInfo && loginInfo.isLogin && loginInfo.isLogin === 'true';

    if (!isLogin) {
      return true;
    }


    if (!loginInfo.moduleName && baseRoute !== 'login' && this.roles.includes(baseRoute)) {
      this.routeDataService.logout.next(true);
      this.routeDataService.unAuthorized.next(true);

      this.router.navigate(['/login'], {queryParams: {returnUrl: route['_routerState'].url}});
      return true;
    }


    if (this.format(loginInfo.moduleName).includes(baseRoute)) {
      this.routeDataService.login.next(true);

      return true;
    }


    if (baseRoute === 'login') {
      this.routeDataService.login.next(true);

      this.router.navigate(['/' + this.format(loginInfo.module)], this.extras);
      return true;
    }


    if (this.roles.includes(baseRoute)) {
      this.routeDataService.logout.next(true);
      this.routeDataService.unAuthorized.next(true);

      this.router.navigate(['/login'], this.extras);
      return true;
    }

    this.router.navigate(['/pageNotFound'], this.extras);
    return null;
  }
}
